import IconButton  from "@material-ui/core/IconButton";
import Snackbar from "@material-ui/core/Snackbar";
import CloseIcon from '@material-ui/icons/Close';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import * as CommonActions from '@services/common/common.action';
import { dismissErrorMessage, dismissSuccessMessage } from '@services/user/user.actions';
import * as React from "react";
import { connect } from 'react-redux';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import {  SnackbarContent } from '@material-ui/core';
import { getOS } from "@helpers/osDetection";
import TranslateNew from '@translate/TranslateNew';
import { styleColors } from "src/main.style";

const tn: TranslateNew = TranslateNew.getInstance();
const SETTINGS_LINK_MARKER = "SETTINGS_LINK";

interface IProps extends RouteComponentProps {
  hasErrorMsg:boolean;
  connectionError: boolean;
  errorMsg:string;
  hasSuccessMsg:boolean;
  successMsg:string;
  id:number;

  bootstrap: (payload: any) => void;
  dismissError: () => void;
  dismissSuccess: () => void;
}


class PPublicRouterSnackbar extends React.Component<IProps> {

  public render() {
    const errorMessageLinksToSettings = hasSettingsLink(this.props.errorMsg);

    return (
      <>
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          open={this.props.hasSuccessMsg}
          autoHideDuration={2000}
          onClose={() => {
            this.props.dismissSuccess(); 
            }
          }
        >
          <SnackbarContent
            style={{backgroundColor:styleColors.callGreen}}
            aria-describedby="client-snackbar"
            message={
              <span id="client-snackbar" style={{display:'flex', alignItems: 'center'}}>
                <CheckCircleIcon />
                <div style={{paddingLeft:'8px'}}>{this.props.successMsg}</div>
              </span>
            }
            action={[
              <IconButton key="close" aria-label="Close" color="inherit" 
                onClick={() => {this.props.dismissSuccess();}}>
                <CloseIcon />
              </IconButton>,
            ]}
          />
        </Snackbar>

        <Snackbar
          key={""+this.props.id}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          open={(this.props.hasErrorMsg && !this.props.hasSuccessMsg)}
          autoHideDuration={4000}
          onClose={() => {
            this.props.dismissError(); 
            // if (this.props.connectionError) {
            //   this.props.bootstrap({
            //     meta: {
            //       history: this.props.history,
            //       location: this.props.location
            //     }
            //   });
            // }
          }}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={<span
            id="message-id"
            onClick={errorMessageLinksToSettings ? openSettings : undefined}
            style={errorMessageLinksToSettings ? {cursor:"pointer"} : undefined}
          >
            {getUpdatedErrorMessage(this.props.errorMsg)}
          </span>}
          action={[
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              onClick={() => {
                this.props.dismissError();
                // if (this.props.connectionError) {
                //   this.props.bootstrap({
                //     meta: {
                //       history: this.props.history,
                //       location: this.props.location
                //     }
                //   });
                // }
              }
            }
            >
              <CloseIcon />
            </IconButton>,
          ]}
        />
      </>
    );
  }
}

function getUpdatedErrorMessage(errorMsg: string): JSX.Element | string {
  const displayErrorMsg = trimSettingsLink(errorMsg);

  if (errorMsg === "A new version is available") {
    const os = getOS();
    const url =
      os === "ANDROID"
        ? "https://play.google.com/store/apps/details?id=app.varannanvecka"
        : "https://apps.apple.com/app/varannan-vecka/id1618305857";

    const openExternal = (e: React.MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();
      // Prefer Cordova InAppBrowser if available
      const w: any = window;
      if (w.cordova?.InAppBrowser) {
        w.cordova.InAppBrowser.open(url, "_system", "location=yes");
      } else {
        // Fallback when running in a regular browser
        window.open(url, "_blank");
      }
    };

    return (
      <a
        href={url}
        onClick={openExternal}
        style={{ color: styleColors.white, textDecoration: "none" }}
        rel="noopener"
        target="_blank"
      >
        {tn.lang.updateAvailable}
      </a>
    );
  }
  return displayErrorMsg;
}

function hasSettingsLink(errorMsg: string): boolean {
  if (!errorMsg) {
    return false;
  }

  return errorMsg.trim().endsWith(SETTINGS_LINK_MARKER);
}

function trimSettingsLink(errorMsg: string): string {
  if (!errorMsg) {
    return "";
  }

  if (!hasSettingsLink(errorMsg)) {
    return errorMsg;
  }

  return errorMsg.trim().slice(0, -SETTINGS_LINK_MARKER.length).trim();
}

function openSettings() {
  const cordova = (globalThis as any).cordova;
  if (cordova?.plugins?.diagnostic?.switchToSettings) {
    cordova.plugins.diagnostic.switchToSettings();
  }
}


function mapStateToProps(state: any) {

  return {
    hasErrorMsg: !state.user.errorMessage.dismissed,
    errorMsg: state.user.errorMessage.message,
    hasSuccessMsg: state.user.successMessage && !state.user.successMessage.dismissed,
    successMsg: state.user.successMessage?state.user.successMessage.message:'',
    connectionError:  state.user.errorMessage.connection,
    id:state.user.errorMessage.id,
  };
}

const mapDispatchToProps = {
  bootstrap: CommonActions.bootstrap,
  dismissError: dismissErrorMessage,
  dismissSuccess: dismissSuccessMessage,
};

const PublicRouterSnackbar = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(PPublicRouterSnackbar);

export default PublicRouterSnackbar;



// WEBPACK FOOTER //
// ./src/router/public.router.snackbar.tsx